import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, merge, of } from 'rxjs';
import { HeaderVariant, LayoutRouteData } from '@layout/models/layout.model';
import { SkipLinkComponent } from '@shared/components/skip-link/skip-link.component';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
  selector: 'app-site-layout',
  standalone: true,
  imports: [RouterOutlet, SkipLinkComponent, SiteHeaderComponent, SiteFooterComponent],
  templateUrl: './site-layout.component.html',
})
export class SiteLayoutComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  private readonly layoutData = toSignal(
    merge(
      of(null),
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)),
    ).pipe(map(() => this.readLayoutData())),
    { initialValue: {} as LayoutRouteData },
  );

  protected readonly headerVariant = computed<HeaderVariant>(
    () => this.layoutData().headerVariant ?? 'minimal',
  );

  private readLayoutData(): LayoutRouteData {
    const snapshot = this.getDeepestSnapshot(this.route.snapshot);
    return (snapshot.data as LayoutRouteData) ?? {};
  }

  private getDeepestSnapshot(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = snapshot;

    while (current.firstChild) {
      current = current.firstChild;
    }

    return current;
  }
}
